import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';

const SecurityBadges: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-6 py-6 border-t border-gray-800 mt-8">
      <div className="flex items-center gap-2 text-gray-400">
        <ShieldCheck className="text-green-500" size={24} />
        <div className="flex flex-col">
          <span className="text-xs font-bold text-gray-300 uppercase">Site Seguro</span>
          <span className="text-[10px]">Google Safe Browsing</span>
        </div>
      </div>

      <div className="flex items-center gap-2 text-gray-400">
        <Lock className="text-alphamed-gold" size={24} />
        <div className="flex flex-col">
          <span className="text-xs font-bold text-gray-300 uppercase">Certificado SSL</span>
          <span className="text-[10px]">Conexão Criptografada</span>
        </div>
      </div>

      <div className="flex items-center gap-2 text-gray-400">
        <CreditCard className="text-blue-400" size={24} />
        <div className="flex flex-col">
          <span className="text-xs font-bold text-gray-300 uppercase">Pagamento Seguro</span>
          <span className="text-[10px]">Processado via Gateway</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;
